module.exports = __webpack_public_path__ + "img/gle.b872f9e5.jpg";